import { IServerSuffix } from './types'

// 多模块联调时，请使用该配置项,注意：该配置跟`window.CI_DEV_BRANCH`互斥
// 相关讨论：
// https://git.forchange.cn/common/frontend/package/rakete-cli/-/issues/8
// https://git.forchange.cn/common/frontend/package/rakete-cli/-/issues/17
// 按照联调环境，拼接URL规则，默认使用 - 拼接
// 建议通过命令行操作
// yarn server-suffix
// 注意：不建议在这里配置local配置，local 配置在.local/local.config.js下
/**
 * const serverSuffix = {
 *  dev: {
 *     passport: 'login',
 *     code: 'verification'
 *  }
 * }
*/
export const serverSuffix: IServerSuffix = {}
